module.exports = __webpack_public_path__ + "img/play.57c45255.svg";